module.exports = __webpack_public_path__ + "img/leaf_4.7536d5f6.png";